import { get, post, put } from "../request.js";

export const ApiGetAISpeechList = {
  get: (stuid, status) => {
    return get(`/ai_speech/get_list/${stuid}/${status}`);
  },
};

export const ApiGetAISpeechDetail = {
  get: (stuid, ai_sp_id) => {
    return get(`/ai_speech/get_content/${stuid}/${ai_sp_id}`);
  },
};

export const ApiEditAISpeechScore = {
  put: (ai_speech_content_id, score) => {
    return put(`/ai_speech/answer/${ai_speech_content_id}/${score}`);
  },
};
